<template>
    <div class="my-10">
        <LikedNav></LikedNav>
          <h1 class="font-bold text-xl mb-4 hidden max-md:flex">{{ $t('nav.businessLiked') }}</h1>
          <div class="grid grid-cols-4 gap-4 max-lg:grid-cols-3 max-md:grid-cols-2">
              <template v-for="item in this.$store?.businessLiked" :key="item.id">
                  <router-link :to="{ name: 'businessAccountsDetail', params: { id: item.id } }">
                      <BusinessAccountCard @likeAction="likeAction" :detail="item">
                      </BusinessAccountCard>
                  </router-link>
              </template>
              
          </div>
          <div v-show="loading === true" class="flex justify-center mx-auto w-full" role="status">
              <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
              </IconSpinner>
  
              <span class="sr-only">Loading...</span>
          </div>
          <div v-show="this.$store?.businessLiked?.length === 0 && loading === false">
              <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_liked') }}</p>
          </div>
      </div>
  </template>
  
  <script>
  import api from '@/api';
  import BusinessAccountCard from '@cmp/media/BusinessAccountCard.vue'
  import LikedNav from '@cmp/profile/LikedNav.vue'
  export default {
      name: 'businessLiked',
      components: {
          LikedNav,
          BusinessAccountCard,
      },
      data(){
          return {
              loading: false,
              products: []
          }
      },
      methods: {
          
          async likeAction(id, like) {
              if (this.$store.authStatus === false) {
                  this.$store.setState('loginModal', true)
                  return
              }
              try {
                  const response = await api.post(`posts/business_accounts/${id}/like/`, { is_liked: like });
                  this.$store.getLiked('business')
              } catch (e) {
                  console.log(e)
              }
          },
      },
      computed: {
  
      },
    created(){
      }
  }
  
  </script>
  <style scoped>
  .router-link-exact-active{
      border-bottom: 1px solid #409DBA;
      color: #000000;
  }
  </style>